import {
  ADMIN_RECEIVABLES,
  ADMIN_RECEIVABLES_LOCATION,
} from '@vgrubs/components';
import { Navigate, generatePath, useParams } from 'react-router';

/**
 * The pages were at `/receivables` until they became "Outstanding Balances";
 * links from before (the test plan, chats) land on the same page here.
 */
export const OldReceivablesRedirect = () => {
  const { locationId } = useParams();
  return (
    <Navigate
      replace
      to={
        locationId
          ? generatePath(ADMIN_RECEIVABLES_LOCATION, { locationId })
          : ADMIN_RECEIVABLES
      }
    />
  );
};
